<script lang="ts">
	import czechFlag from "@core/assets/cs.svg?raw";
	import englishFlag from "@core/assets/en.svg?raw";
	import slovakFlag from "@core/assets/sk.svg?raw";
	import { Locale } from "@core/schema/Locale.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import Button from "./common/Button.svelte";
	import Icon from "./common/Icon.svelte";
	import Link from "./common/Link.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const {
		locales,
		pagePath,
		currentLocale,
		mobileSimple = false,
	}: {
		locales: Locale[];
		pagePath: Partial<Record<string, string>>;
		currentLocale: Locale;
		mobileSimple?: boolean;
	} = $props();

	const localeNameMapForMenu: Record<Locale, { name: string; icon: string }> = {
		[Locale.cs]: {
			name: "Česky",
			icon: czechFlag,
		},
		[Locale.en]: {
			name: "English",
			icon: englishFlag,
		},
		[Locale.sk]: {
			name: "Slovensky",
			icon: slovakFlag,
		},
	};

	let isLanguageListOpen = $state(false);

	function toggleLanguageList(): void {
		isLanguageListOpen = !isLanguageListOpen;
	}
</script>

{#if mobileSimple}
	<div class="flex items-center justify-center gap-4">
		{#each locales as locale (locale)}
			<Link
				variant={ButtonVariant.Transparent}
				class="flex flex-col items-center gap-1 text-xs font-medium transition-all duration-300 ease-in-out rounded-lg px-2 py-1 {locale ===
				currentLocale
					? 'opacity-100'
					: 'opacity-60 hover:opacity-100'}"
				href={pagePath[locale] ?? getHomepagePath(locale)}
			>
				<span class="w-8 h-8">
					<Icon class="w-full h-full object-cover rounded-full" icon={localeNameMapForMenu[locale].icon} />
				</span>
				<span class="text-xs font-semibold uppercase">{locale.toUpperCase()}</span>
			</Link>
		{/each}
	</div>
{:else if locales.length <= 2}
	{#each locales as locale (locale)}
		{#if locale !== currentLocale}
			<Link
				variant={ButtonVariant.Transparent}
				class="flex items-center gap-2 text-xs font-medium tracking-wide transition-all duration-300 ease-in-out rounded-lg px-2 py-1 hover:text-primary"
				href={pagePath[locale] ?? getHomepagePath(locale)}
			>
				<span class="flex items-center gap-2">
					<span class="w-6 h-6 hidden md:inline-block"></span>
					<span class="text-xs font-semibold uppercase">{locale.toUpperCase()}</span>
					<span class="text-xs text-gray-500">({localeNameMapForMenu[locale].name})</span>
					<span class="w-6 h-6"></span>
					<span class="w-6 h-6 md:w-6 md:h-6 lg:w-6 lg:h-6 xl:w-6 xl:h-6">
						<Icon class="w-full h-full object-cover rounded-full" icon={localeNameMapForMenu[locale].icon} />
					</span>
				</span>
			</Link>
		{/if}
	{/each}
{:else}
	<div class="group relative">
		<Button
			variant={ButtonVariant.Transparent}
			class="flex items-center gap-2 text-xs font-medium uppercase tracking-wide transition-all duration-300 ease-in-out rounded-lg px-2 py-1 hover:text-primary"
			onclick={toggleLanguageList}
		>
			<span class="flex items-center gap-2">
				<span class="text-xs font-semibold uppercase">{currentLocale.toUpperCase()}</span>
				<span class="text-xs text-gray-500">({localeNameMapForMenu[currentLocale].name})</span>
				<span class="w-6 h-6 md:w-6 md:h-6 lg:w-6 lg:h-6 xl:w-6 xl:h-6">
					<Icon class="w-full h-full object-cover rounded-full" icon={localeNameMapForMenu[currentLocale].icon} />
				</span>
			</span>
		</Button>
		<div
			class="absolute left-1/2 top-[calc(100%+.25rem)] w-[calc(100%+1rem)] -translate-x-1/2 rounded-lg bg-white shadow-sm transition-opacity duration-300 ease-in-out lg:after:absolute lg:after:-top-1 lg:after:left-0 lg:after:right-0 lg:after:h-1 lg:after:w-full lg:after:content-[''] lg:group-hover:pointer-events-auto lg:group-hover:opacity-100 {isLanguageListOpen
				? 'pointer-events-auto opacity-100 lg:pointer-events-none lg:opacity-0'
				: 'pointer-events-none opacity-0 lg:pointer-events-none lg:opacity-0'}"
		>
			<ul class="py-2">
				{#each locales as locale (locale)}
					{#if locale !== currentLocale}
						<li>
							<Link
								class="flex items-center gap-3 px-4 py-2 rounded-lg transition-colors duration-200 hover:bg-primary/10 focus:bg-primary/20 text-xs font-medium uppercase tracking-wide text-gray-700 hover:text-primary focus:outline-none"
								href={pagePath[locale] ?? getHomepagePath(locale)}
							>
								<span
									class="w-6 h-6 rounded-full overflow-hidden border border-gray-200 shadow-sm flex-shrink-0 bg-white"
								>
									<Icon class="w-full h-full object-cover rounded-full" icon={localeNameMapForMenu[locale].icon} />
								</span>
								<span class="flex flex-col items-start">
									<span>{localeNameMapForMenu[locale].name}</span>
									<span class="text-[0.7em] text-gray-400">{locale.toUpperCase()}</span>
								</span>
							</Link>
						</li>
					{/if}
				{/each}
			</ul>
		</div>
	</div>
{/if}
